export enum Page {
  Intro,
  Metrics,
  Library,
  SQL,
  Visual,
  Final,
}
